/* global axios */
import ApiClient from './ApiClient';

// Meta Info (aba no settings da inbox): perfil comercial do número WhatsApp
// Cloud na Meta — foto, nome de exibição, categoria, descrição, endereço,
// e-mail e sites (mesmos campos do WhatsApp Manager).
class MetaInfoAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/meta_info`);
  }

  update(inboxId, profile) {
    return axios.post(`${this.url}/${inboxId}/update_meta_info`, profile);
  }

  uploadPicture(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${inboxId}/meta_info_picture`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  requestDisplayName(inboxId, name) {
    return axios.post(`${this.url}/${inboxId}/meta_info_display_name`, {
      name,
    });
  }
}

export default new MetaInfoAPI();
